<template>
    <div class="information">
        <div class="main">
            <p v-if="this.$router.path='/resumezp'"
               class="title">基础信息<span class="sign">必填</span></p>
            <p v-else
               class="title">应聘人基础信息<span class="sign">必填</span></p>
            <div v-show="information"
                 class="information-main">
                <h3>{{ruleForm.name}}</h3>
                <p><span>{{ruleForm.cityname}}</span><i class="el-icon-minus"></i><span>{{ruleForm.highEducationName}}</span><i class="el-icon-minus"></i><span>{{ruleForm.sex}}</span></p>
                <p><i class="el-icon-mobile-phone"><span>{{ruleForm.phone}}</span></i><i class="el-icon-message"><span>{{ruleForm.email}}</span></i><i class="el-icon-edit-outline"
                       @click="changeinformation()"></i></p>
            </div>
            <el-form v-show="!information"
                     :model="ruleForm"
                     :rules="rules"
                     ref="ruleForm"
                     :inline="true"
                     label-position="top"
                     label-width="100px"
                     class="demo-ruleForm">
                <el-form-item label="姓名"
                              prop="name">
                    <el-input placeholder="请输入姓名"
                              maxlength="30"
                              v-model="ruleForm.name"></el-input>
                </el-form-item>
                <el-form-item label="出生年月"
                              prop="birth">
                    <el-date-picker v-model="ruleForm.birth"
                                    type="month"
                                    placeholder="选择出生年月">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="性别"
                              prop="sex">
                    <el-radio-group v-model="ruleForm.sex">
                        <el-radio label="男"></el-radio>
                        <el-radio label="女"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="工作年限"
                              prop="workExperience">
                    <el-select v-model="ruleForm.workExperience"
                               placeholder="请选择工作年限">
                        <el-option v-for="(item,index) in searchlenghtlist"
                                   :key="index"
                                   :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="手机号"
                              prop="phone">
                    <el-input placeholder="请输入手机号"
                              maxlength="11"
                              v-model="ruleForm.phone"></el-input>
                </el-form-item>
                <el-form-item label="邮箱"
                              prop="email">
                    <el-input placeholder="请输入邮箱"
                              maxlength="50"
                              v-model="ruleForm.email"></el-input>
                </el-form-item>
                <el-form-item label="最高学历"
                              prop="highEducation">
                    <el-select v-model="ruleForm.highEducation"
                               placeholder="请选择最高学历"
                               @change="changehighEducation()">
                        <el-option v-for="(item,index) in highEducationlist"
                                   :key="index"
                                   :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="所在城市"
                              prop="citys">
                    <el-cascader :options="options"
                                 :props="props"
                                 filterable
                                 v-model="ruleForm.citys">
                    </el-cascader>
                </el-form-item>
                <el-form-item v-show="informationbtn"
                              style=" display:block;
                                    text-align:center;
                                    margin:26px 0;">
                    <el-button type="primary"
                               @click="subitinformation('ruleForm')">保存</el-button>
                    <el-button @click="quxiaoinformation('ruleForm')">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import {
    selecteducationtype,
    queryprovinceandcity,
    selectworkage
} from "@/api/homePage";
import { saveorupdatepersoninfo, selectbasicinfo } from "@/api/apiall";
import { getUsers } from "@/api/login";
export default {
    data() {
        return {
            informationbtn: false,
            information: true,
            informationdata: {},
            highEducationlist: [],
            searchlenghtlist: [],
            ruleForm: {
                id: "",
                userId: "",
                name: "",
                workExperience: "",
                phone: "",
                highEducation: "",
                email: "",
                citys: [],
                birth: "",
                sex: ""
            },
            options: [],
            props: {
                label: "name",
                value: "code",
                children: "child"
            },
            highEducationtext: "",
            rules: {
                name: [
                    {
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur"
                    }
                ],
                birth: [
                    {
                        required: true,
                        message: "请选择出生年月",
                        trigger: "change"
                    }
                ],
                sex: [
                    {
                        required: true,
                        message: "请选择性别",
                        trigger: "change"
                    }
                ],
                workExperience: [
                    {
                        required: true,
                        message: "请选择工作年限",
                        trigger: "change"
                    }
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur"
                    },
                    {
                        pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
                        message: "请输入正确格式",
                        trigger: "blur"
                    }
                ],
                email: [
                    {
                        required: true,
                        message: "请输入邮箱",
                        trigger: "blur"
                    },
                    {
                        pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
                        message: "请输入正确格式",
                        trigger: "blur"
                    }
                ],
                highEducation: [
                    {
                        required: true,
                        message: "请选择最高学历",
                        trigger: "change"
                    }
                ],
                citys: [
                    {
                        required: true,
                        message: "请选择所在城市",
                        trigger: "change"
                    }
                ]
            }
        };
    },
    watch: {
        $route(to, from) {
            if (to.path == "/Curriculumvitae") {
                this.information = true;
                this.informationbtn = true;
            } else {
                this.information = false;
                this.informationbtn = false;
            }
        },
        "ruleForm.highEducation": {
            handler(newName, oldName) {
                if (newName == 4 || newName == 5) {
                    this.$emit("fatherMethod");
                } else {
                    this.$emit("fatherdisplay");
                }
            },
            immediate: true
        }
    },
    created() {
        if (this.$route.path == "/Curriculumvitae") {
            this.information = true;
            this.informationbtn = true;
        } else {
            this.information = false;
            this.informationbtn = false;
        }
        this.search();
        this.querycity();
        this.searchlenght();
        if (
            this.$route.path == "/Curriculumvitae" ||
            this.$route.path == "/resumezp"
        ) {
            if (sessionStorage.getItem("userId") != "undefined") {
                this.getUserId();
            }
        }
    },
    methods: {
        getUserId() {
            if (
                sessionStorage.getItem("userId") == null ||
                sessionStorage.getItem("userId") == undefined
            ) {
                getUsers().then(res => {
                    this.ruleForm.userId = res.userId;
                    this.searchpre();
                });
            } else {
                this.ruleForm.userId = sessionStorage.getItem("userId");
                this.searchpre();
            }
        },
        search() {
            selecteducationtype().then(res => {
                if (res.status === 2000) {
                    this.highEducationlist = res.data;
                }
            });
        },
        searchlenght() {
            selectworkage().then(res => {
                if (res.status === 2000) {
                    this.searchlenghtlist = res.data;
                }
            });
        },
        //查询基本信息
        searchpre() {
            selectbasicinfo({ userId: this.ruleForm.userId }).then(res => {
                if (res.status === 2000) {
                    if (res.data) {
                        this.ruleForm = res.data;
                        sessionStorage.setItem(
                            "informationId",
                            res.data.personId
                        );
                    } else {
                        this.information = false;
                    }
                } else {
                    this.information = false;
                }
            });
        },
        restinformation(formName) {
            this.$refs[formName].resetFields();
        },
        querycity() {
            queryprovinceandcity({ code: "-1" }).then(res => {
                if (res.status === 2000) {
                    this.options = res.data;
                }
            });
        },
        changeinformation() {
            this.information = false;
            // this.$refs[formName].resetFields();
        },
        subitinformation(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.ruleForm.id = sessionStorage.getItem("informationId");
                    this.ruleForm.userId = sessionStorage.getItem("userId");
                    saveorupdatepersoninfo(this.ruleForm).then(res => {
                        if (res.status === 2000) {
                            this.$message({
                                message: "提交成功",
                                type: "success"
                            });
                            this.information = true;
                            this.searchpre();
                        } else {
                            this.$message({
                                message: res.data,
                                type: "warning"
                            });
                        }
                    });
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        quxiaoinformation(formName) {
            this.$refs[formName].resetFields();
            this.information = true;
            this.searchpre();
        },
        changehighEducation() {
            console.log(this.highEducationlist);
            for (
                let index = 0;
                index < this.highEducationlist.length;
                index++
            ) {
                if (
                    this.ruleForm.highEducation ==
                    this.highEducationlist[index].value
                ) {
                    if (
                        this.highEducationlist[index].label == "高中" ||
                        this.highEducationlist[index].label == "高中以下"
                    ) {
                        this.$emit("fatherMethod");
                    } else {
                        this.$emit("fatherdisplay");
                    }
                }
            }
        },
        handleSubmit(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$emit("informationByValue", this.ruleForm);
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        }
    }
};
</script>


<style scoped lang="scss">
.information {
    width: 900px;
    background-color: #fff;
    float: left;
    position: relative;
    .main {
        padding: 30px;
        border-bottom: 1px solid #ddd;
        h3 {
            padding-bottom: 20px;
            span {
                margin-left: 20px;
                font-size: 16px;
                font-weight: 500;
                cursor: pointer;
            }
            span:hover {
                color: #fabe00;
            }
        }
        .title {
            font-size: 18px;
            color: #333;
            padding-top: 10px;
        }
        .sign {
            display: inline-block;
            margin-left: 12px;
            position: relative;
            top: -2px;
            width: 37px;
            height: 18px;
            color: #fff;
            background-color: #fabe00;
            text-align: center;
            line-height: 16px;
            font-size: 12px;
            border-radius: 4px;
        }
        .information-main {
            h3 {
                margin-top: 20px;
            }
            p {
                line-height: 34px;
                position: relative;
                .el-icon-minus {
                    transform: rotate(90deg);
                    -ms-transform: rotate(90deg); /* IE 9 */
                    -moz-transform: rotate(90deg); /* Firefox */
                    -webkit-transform: rotate(90deg); /* Safari 和 Chrome */
                    -o-transform: rotate(90deg);
                    padding: 0 10px;
                    color: #ccc;
                }
                i {
                    color: #fabe00;
                    font-size: 18px;
                    padding-right: 10px;
                    span {
                        margin-left: 10px;
                        color: #000;
                        font-size: 14px;
                    }
                }
                .el-icon-message {
                    padding-left: 10px;
                }
                .el-icon-edit-outline {
                    font-size: 25px;
                    cursor: pointer;
                    position: absolute;
                    right: 10px;
                }
            }
        }
        .el-form {
            margin-top: 20px;
            margin-bottom: 20px;
            .el-input,
            .el-cascader,
            .el-select {
                width: 230px;
            }
            /deep/ .el-form-item {
                margin-bottom: 6px !important;
                .el-form-item__label {
                    padding: 0 !important;
                }
            }
        }

        .el-form--label-top .el-form-item__label {
            padding: 0;
        }
        .el-form--inline .el-form-item {
            margin-right: 30px;
        }
    }
}
</style>
